import { type CSSProperties } from 'react';

import { FONT_INTER } from './blueprint-view-styles';

/**
 * PDF casting table: tableCasting width 30%, tableCastingHeaderRow bg #A5A5A5
 * color #fff, fontSize 10pt, tableCastingCell fontSize 10pt, width 1in, padding 5pt.
 * Rows alternate #eee / #d9d9d9. Border separators are 1px solid white.
 *
 * In our scaled context (14px = 10pt), we use 'inherit' for fontSize
 * so it matches the page wrapper base. Padding 5pt -> 7px.
 */

export const SIGNOFF_TABLE_STYLE: CSSProperties = {
	borderCollapse: 'collapse',
	fontFamily: FONT_INTER,
	fontWeight: 400,
	textAlign: 'center',
	width: '30%'
};

const BASE_CELL_STYLE: CSSProperties = {
	padding: '4px 7px',
	height: '20px',
	verticalAlign: 'middle',
	textAlign: 'center',
	width: '1in'
};

export const SIGNOFF_HEADER_CELL_STYLE: CSSProperties = {
	...BASE_CELL_STYLE,
	backgroundColor: '#A5A5A5',
	color: 'white',
	fontWeight: 700,
	borderRight: '1px solid white'
};

export const SIGNOFF_HEADER_CELL_LAST_STYLE: CSSProperties = {
	...BASE_CELL_STYLE,
	backgroundColor: '#A5A5A5',
	color: 'white',
	fontWeight: 700
};

export const SIGNOFF_DATA_CELL_STYLE: CSSProperties = {
	...BASE_CELL_STYLE,
	borderRight: '1px solid white'
};

export const SIGNOFF_DATA_CELL_LAST_STYLE: CSSProperties = {
	...BASE_CELL_STYLE
};

export const SIGNOFF_ROW_STYLE: CSSProperties = {
	backgroundColor: '#eee'
};

export const SIGNOFF_ALT_ROW_STYLE: CSSProperties = {
	backgroundColor: '#d9d9d9'
};
